<div class="margin-top-lg">
<mat-card-title class="h5">
	Phone
	<span class="align-btn">

		<button *ngIf="!readOnly && editing" mat-raised-button color="primary" (click)="addRow()">
			Add Phone
		</button>
	</span>
</mat-card-title>

<mat-accordion class="margin-top-lg">
	<mat-expansion-panel disabled="true" [expanded]="true" hideToggle="true">
		<div *ngIf="partyId!>0 && kidsInfoByCoe && editing">
			<app-view-coe-child-info [partyId]="partyId" [CoeRelatedStudents]="CoeRelatedStudents"
				[spinner]="coeChildSpinner" (eventCoeStudents)="coeStudentsEventEmitter($event)">
			</app-view-coe-child-info>
		</div>
		<div class="table-responsive">
			<mat-table [dataSource]="dataSource" *ngIf="dataSource.data.length>0" class="mat-elevation-z1">
				<ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
					<mat-header-cell *matHeaderCellDef [ngClass]="{'phoneTypeWidth': col.key == 'phoneType' }">
						<h4>{{ col.label }}</h4>
					</mat-header-cell>
					<mat-cell *matCellDef="let element" [ngClass]="{'past-row':  !isRowEditable(element)}">
						<div [ngSwitch]="col.key" *ngIf="!element.isEdit">
							<div *ngSwitchCase="'isEdit'" class="btn-edit">
								<div *ngIf="isRowEditable(element) && editing">
									<button *ngIf="!readOnly" mat-icon-button color="primary"
										(click)="editRow(element)">
										<mat-icon>edit</mat-icon>
									</button>
									<button *ngIf="!readOnly" mat-icon-button color="warn"
										(click)="RemoveCallCoeRelatedStudents(element)">
										<mat-icon>delete</mat-icon>
									</button>
								</div>
								<div *ngIf="!isRowEditable(element)" style="color:red">
									Past Phone Number
								</div>
							</div>
							<div *ngSwitchCase="'activeDate'">
								{{ element.partyContactMechanisms?.CREATED_DATE | simpleDate }}
							</div>
							<div *ngSwitchCase="'phoneType'">
								{{element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES
								?
								element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE
								: ''
								}}
							</div>
							<div *ngSwitchCase="'phone'">
								{{element.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER
								+
								(element.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT ? ' Ext. '
								+
								element.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT : '')}}
							</div>
						</div>

						<div [ngSwitch]="col.key" *ngIf="element.isEdit">
							<div *ngSwitchCase="'activeDate'">
								{{ element.partyContactMechanisms.CREATED_DATE | simpleDate }}
							</div>
							<div *ngSwitchCase="'phoneType'">
								<div *ngIf="!element.isDelete">
									<mat-form-field>
										<mat-label>Phone Type</mat-label>
										<mat-select
											[(ngModel)]="element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES?.[0].CONTACT_MECHANISM_PURPOSE_TYPES"
											[compareWith]="compareFn" required="true">
											<mat-option *ngFor="let type of contactMechanismPurposeTypes "
												[value]="type">
												{{type.TYPE}}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div *ngIf="element.isDelete">
									{{element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES
									?
									element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE
									: ''
									}}
								</div>
							</div>

							<div *ngSwitchCase="'phone'">
								<div *ngIf="!element.isDelete">
									<mat-form-field>
										<mat-label>Phone</mat-label>
										<input matInput type="string" id="PhoneNumber" name="PhoneNumber"
											placeholder="123-456-7890"
											[(ngModel)]="element.partyContactMechanisms.CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].PHONE_NUMBER"
											required="true" telephoneValidator>
									</mat-form-field>

								</div>
								<div *ngIf="element.isDelete">
									{{element.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER
									+
									(element.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT ? '
									Ext. '
									+
									element.partyContactMechanisms.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT : '')}}
								</div>
							</div>

							<div *ngSwitchCase="'isEdit'">
								<div *ngIf="!element.isDelete">
									<div class="row">
										<div class="col">
											<button mat-mini-fab color="primary" (click)="updateRow(element)"
												[disabled]="disableSubmit(element)">
												<mat-icon>done</mat-icon>
											</button>
										</div>
										<div class="col">
											<button mat-mini-fab (click)="cancelRow(element)">
												<mat-icon class="icon-display">cancel</mat-icon>
											</button>
										</div>
									</div>

								</div>
								<div *ngIf="element.isDelete && !coeChildSpinner">
									<div class="row">
										<div class="col">
											<button mat-mini-fab color="primary" (click)="deleteRow(element)">
												<mat-icon>delete_forever</mat-icon>
											</button>
										</div>
										<div class="col">
											<button mat-mini-fab (click)="cancelRow(element)">
												<mat-icon class="icon-display">cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>

					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'past-row':  !isRowEditable(row)}">
				</mat-row>
			</mat-table>
		</div>
		<mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
			aria-label="Select page of periodic elements">
		</mat-paginator>
	</mat-expansion-panel>
</mat-accordion>
</div>